export { PagesCard } from "./PagesCard";
